document.addEventListener('click', async (event) => {
  const targetBtn = event.target.closest('.quick-look-btn');
  if (!targetBtn) return;

  event.preventDefault();

  const modalOverlay = document.getElementById('QuickLookModal');
  const modalContent = document.getElementById('QuickLookContent');

  if (!modalOverlay || !modalContent) return;

  const handle = targetBtn.dataset.productHandle || targetBtn.dataset.handle;
  if (!handle) return;

  // Reset display state & setup loading indicator
  modalOverlay.style.removeProperty('display');
  modalContent.innerHTML = '<p style="color: #ffffff; text-align: center; padding: 2rem;">Loading details...</p>';
  modalOverlay.classList.add('is-active');
  modalOverlay.setAttribute('aria-hidden', 'false');

  try {
    const rootPath = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootPath}products/${handle}.js`);
    
    if (!response.ok) throw new Error('Failed to load product');

    const product = await response.json();
    
    // Images Gallery Setup
    const images = product.images && product.images.length > 0 ? product.images : [product.featured_image].filter(Boolean);
    const mainImage = images[0] || '';

    // Price Formatting Helper
    const formatMoney = (cents) => {
      if (typeof cents !== 'number') return '';
      const currency = window.Shopify?.currency?.active || 'USD';
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency
      });
    };

    // Variants & Options setup
    const options = product.options || [];
    const variants = product.variants || [];
    const initialVariant = variants[0];

    // Image Gallery HTML with Prev/Next Arrow Buttons
    const galleryHTML = `
      <div class="ql-gallery">
        <div class="ql-main-image">
          ${images.length > 1 ? `
            <button type="button" class="ql-arrow ql-prev" aria-label="Previous image">&#10094;</button>
          ` : ''}
          <img id="QLMainImg" src="${mainImage}" alt="${product.title}">
          ${images.length > 1 ? `
            <button type="button" class="ql-arrow ql-next" aria-label="Next image">&#10095;</button>
          ` : ''}
        </div>
        ${images.length > 1 ? `
          <div class="ql-thumbnails">
            ${images.map((img, index) => `
              <button type="button" class="ql-thumb-btn ${index === 0 ? 'is-active' : ''}" data-src="${img}" data-index="${index}">
                <img src="${img}" alt="">
              </button>
            `).join('')}
          </div>
        ` : ''}
      </div>
    `;

    // Option / Variation Buttons HTML
    let optionsHTML = '';
    if (options.length > 0 && !(options.length === 1 && options[0].name === 'Title' && options[0].values.includes('Default Title'))) {
      optionsHTML = options.map((option, optionIndex) => {
        return `
          <div class="ql-option-group" data-option-index="${optionIndex}">
            <label class="ql-option-label">${option.name}</label>
            <div class="ql-option-values">
              ${option.values.map((value, valIndex) => `
                <button type="button" 
                  class="ql-variant-btn ${valIndex === 0 ? 'is-selected' : ''}" 
                  data-option-index="${optionIndex}" 
                  data-value="${value.replace(/"/g, '&quot;')}">
                  ${value}
                </button>
              `).join('')}
            </div>
          </div>
        `;
      }).join('');
    }

    // Price Display HTML Helper
    const getPriceHTML = (variant) => {
      if (!variant) return '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return `
          <span class="ql-sale-price" style="color: #c5a059; font-weight: bold; margin-right: 8px;">${formatMoney(variant.price)}</span>
          <s class="ql-compare-price" style="opacity: 0.6; text-decoration: line-through;">${formatMoney(variant.compare_at_price)}</s>
        `;
      }
      return `<span>${formatMoney(variant.price)}</span>`;
    };

    // Populate Modal Content
    modalContent.innerHTML = `
      <div class="quick-look-grid">
        <div class="quick-look-media">
          ${galleryHTML}
        </div>
        <div class="quick-look-info">
          <h2 id="QuickLookTitle" class="product-title">${product.title}</h2>
          <div class="price" id="QLPrice" style="margin: 0.75rem 0; font-size: 1.2rem;">${getPriceHTML(initialVariant)}</div>
          
          <form id="QLAddToCartForm" data-product-form>
            ${optionsHTML}
            <input type="hidden" name="id" id="QLVariantId" value="${initialVariant?.id || ''}">
            
            <div class="ql-quantity-wrapper" style="margin-top: 1.25rem;">
              <label class="ql-option-label" for="QLQuantity">Quantity</label>
              <div class="ql-quantity-selector">
                <button type="button" class="ql-qty-btn ql-qty-minus" aria-label="Decrease quantity">-</button>
                <input type="number" id="QLQuantity" name="quantity" value="1" min="1" class="ql-qty-input" readonly>
                <button type="button" class="ql-qty-btn ql-qty-plus" aria-label="Increase quantity">+</button>
              </div>
            </div>

            <button type="submit" class="add-to-cart-btn" id="QLSubmitBtn" style="margin-top: 1.25rem;" ${!initialVariant?.available ? 'disabled' : ''}>
              ${initialVariant?.available ? 'Add to Cart' : 'Sold Out'}
            </button>
          </form>

          <div class="product-description" style="margin-top: 1.5rem;">
            ${product.description || ''}
          </div>
        </div>
      </div>
    `;

    // Quantity Selector Event Listeners
    const qtyInput = modalContent.querySelector('#QLQuantity');
    const minusBtn = modalContent.querySelector('.ql-qty-minus');
    const plusBtn = modalContent.querySelector('.ql-qty-plus');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value, 10) || 1;
        if (currentVal > 1) {
          qtyInput.value = currentVal - 1;
        }
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = currentVal + 1;
      });
    }

    // Wrap injected size chart tables inside scrollable containers
    modalContent.querySelectorAll('.product-description table').forEach((table) => {
      if (!table.parentElement.classList.contains('size-chart-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'size-chart-wrapper';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });

    // Active Gallery Image Index Manager
    let currentImageIndex = 0;
    const mainImgEl = document.getElementById('QLMainImg');

    const updateGalleryImage = (index) => {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentImageIndex = index;

      if (mainImgEl) mainImgEl.src = images[currentImageIndex];

      const thumbBtns = modalContent.querySelectorAll('.ql-thumb-btn');
      thumbBtns.forEach((thumb, idx) => {
        if (idx === currentImageIndex) {
          thumb.classList.add('is-active');
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          thumb.classList.remove('is-active');
        }
      });
    };

    // Arrow Button Click Events
    const prevBtn = modalContent.querySelector('.ql-prev');
    const nextBtn = modalContent.querySelector('.ql-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        updateGalleryImage(currentImageIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        updateGalleryImage(currentImageIndex + 1);
      });
    }

    // Thumbnail Click Event
    modalContent.querySelectorAll('.ql-thumb-btn').forEach((thumb, idx) => {
      thumb.addEventListener('click', () => {
        updateGalleryImage(idx);
      });
    });

    // Helper to Normalize URLs for Matching
    const normalizeUrl = (url) => url ? url.replace(/^https?:/, '').split('?')[0] : '';

    // Variant Selection Logic & Image Swapping
    const variantInput = document.getElementById('QLVariantId');
    const submitBtn = document.getElementById('QLSubmitBtn');
    const priceContainer = document.getElementById('QLPrice');

    modalContent.querySelectorAll('.ql-variant-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const optionGroup = e.target.closest('.ql-option-group');
        optionGroup.querySelectorAll('.ql-variant-btn').forEach(b => b.classList.remove('is-selected'));
        e.target.classList.add('is-selected');

        const selectedOptions = [];
        modalContent.querySelectorAll('.ql-option-group').forEach(group => {
          const activeBtn = group.querySelector('.ql-variant-btn.is-selected');
          if (activeBtn) selectedOptions.push(activeBtn.dataset.value);
        });

        const matchedVariant = variants.find(variant => {
          return variant.options.every((optValue, idx) => optValue === selectedOptions[idx]);
        });

        if (matchedVariant) {
          variantInput.value = matchedVariant.id;

          // Update Price
          if (priceContainer) priceContainer.innerHTML = getPriceHTML(matchedVariant);

          // Sync image if variant has a unique featured image
          if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
            const variantImgSrc = matchedVariant.featured_image.src;
            const targetIndex = images.findIndex(img => normalizeUrl(img) === normalizeUrl(variantImgSrc));
            if (targetIndex !== -1) {
              updateGalleryImage(targetIndex);
            }
          }

          // Update Button Availability
          if (matchedVariant.available) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Cart';
          } else {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sold Out';
          }
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Unavailable';
        }
      });
    });

    // AJAX Add to Cart Submission
    const addToCartForm = document.getElementById('QLAddToCartForm');
    if (addToCartForm) {
      addToCartForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        if (!submitBtn || submitBtn.disabled) return;

        const originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';

        try {
          const formData = new FormData(addToCartForm);
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (response.ok) {
            submitBtn.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

            setTimeout(() => {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }, 1500);
          } else {
            throw new Error('Cart add failed');
          }
        } catch (err) {
          console.error('Add to Cart Error:', err);
          submitBtn.textContent = 'Error Adding';
          setTimeout(() => {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 2000);
        }
      });
    }

  } catch (error) {
    console.error('Quick Look Error:', error);
    modalContent.innerHTML = '<p style="color: #ffffff; text-align: center; padding: 2rem;">Unable to load product details.</p>';
  }
});

// Close Modal Handler
const closeQuickLookModal = () => {
  const modalOverlay = document.getElementById('QuickLookModal');
  if (modalOverlay) {
    modalOverlay.classList.remove('is-active');
    modalOverlay.setAttribute('aria-hidden', 'true');
    modalOverlay.style.setProperty('display', 'none', 'important');
  }
};

document.addEventListener('click', (event) => {
  const modalOverlay = document.getElementById('QuickLookModal');
  if (!modalOverlay) return;

  if (event.target.closest('#QuickLookClose') || event.target === modalOverlay) {
    closeQuickLookModal();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeQuickLookModal();
  }
});